<template>
  <v-card elevation="0">
    <v-toolbar>
      <template v-slot:extension>
        <v-tabs v-model="tab" fixed-tabs color="#9E1C20">
          <v-tabs-slider></v-tabs-slider>
          <v-tab v-for="item in tab_items" :key="item" style="font-size: 12pt">
            {{ item }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-container>
        <v-tab-item>
          <h3 class="mt-5">ບັນຫາພາລວຍ</h3>
          <p>ປະຈຳວັນທີ: {{ formattedDate6 }}</p>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col
                  v-for="(detail, index) in latestItem6?.detail?.slice(0, 8)"
                  :key="index"
                  cols="12"
                  sm="6"
                  md="3"
                >
                  <v-img
                    :src="detail?.puzzle_image"
                    alt="Image"
                    @click="openDialog(detail)"
                    style="cursor: pointer; width: 100%"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <h3 class="mt-5">ບັນຫາພາລວຍເລກລາສີ</h3>
          <p>ປະຈຳວັນທີ: {{ formattedDate12 }}</p>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col
                  v-for="(detail, index) in latestItem12?.detail?.slice(0, 8)"
                  :key="index"
                  cols="12"
                  sm="6"
                  md="3"
                >
                  <v-img
                    :src="detail?.puzzle_image"
                    alt="Image"
                    @click="openDialog(detail)"
                    style="cursor: pointer; width: 100%"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-container>
    </v-tabs-items>

    <div style="display: flex; justify-content: center">
      <router-link to="/gamepluzzle">
        <v-btn elevation="0" dark color="#9E1C20">
          ເບິ່ງທັງໝົດ
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </router-link>
    </div>

    <v-dialog v-model="dialog" max-width="500" scrollable>
      <v-card>
        <v-card-title style="display: flex; justify-content: space-between">
          <b>ບັນຫາພາລວຍ</b>
          <v-btn color="blue darken-1" text @click="dialog = false">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p style="color: #6e6e6e; margin-top: 5px">
            ເລກນຳໂຊກ: <b>{{ dialogLuckyNumber }}</b>
          </p>
          <v-img :src="dialogImageUrl" contain />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="display: flex; justify-content: flex-end">
          <!-- <a :href="dialogImage" download="dream_pluzzle.jpg">ດາວໂຫລດ</a> -->
          <v-btn
            v-if="btn === false"
            color="error"
            elevation="0"
            @click="downloadImage(dialogImageUrl)"
            ><v-icon>mdi-download</v-icon>ດາວໂຫລດ</v-btn
          >
          <v-btn v-if="btn === true" color="success" text
            ><v-icon>mdi-check-circle-outline</v-icon>ດາວໂຫລດແລ້ວ</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
// import { genSignature } from "@/plugins/gen";
import router from "@/router";

export default {
  data() {
    return {
      btn: false,
      tab: null,
      tab_items: ["ບັນຫາພາລວຍ", "ບັນຫາພາລວຍເລກລາສີ"],
      dialog: false,
      dialogImageUrl: "",
      dialogLuckyNumber: "",
    };
  },
  computed: {
    ...mapGetters("gamePluzzle", ["items6", "items12", "textt"]),
    latestItem6() {
      return this.items6.length
        ? this.items6.reduce((latest, item) =>
            moment(item.round_date).isAfter(moment(latest.round_date))
              ? item
              : latest
          )
        : null;
    },
    latestItem12() {
      return this.items12.length
        ? this.items12.reduce((latest, item) =>
            moment(item.round_date).isAfter(moment(latest.round_date))
              ? item
              : latest
          )
        : null;
    },
    formattedDate6() {
      return this.latestItem6
        ? moment(this.latestItem6.round_date).format("DD/MM/YYYY")
        : "";
    },
    formattedDate12() {
      return this.latestItem12
        ? moment(this.latestItem12.round_date).format("DD/MM/YYYY")
        : "";
    },
  },
  methods: {
    ...mapActions("gamePluzzle", ["GPluzzle6", "GPluzzle12"]),
    async downloadImage(imageUrl) {
      this.btn = true;
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();  
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "downloaded_image.jpg";
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    openDialog(detail) {
      this.btn = false;
      this.dialogImageUrl = detail?.puzzle_image;
      this.dialogLuckyNumber = detail?.lucky_number;
      this.dialog = true;
    },
  },
  async mounted() {
    await this.GPluzzle6();
    await this.GPluzzle12();
  },
};
</script>
